import React from 'react';
import { Section } from './Section';
import { ArrowRight } from 'lucide-react';
export function Bridge() {
  return <Section className="bg-sage-800 text-white" data-id="element-25">
      <div className="max-w-3xl mx-auto" data-id="element-26">
        <p className="text-2xl md:text-3xl font-serif leading-relaxed text-center mb-10 text-sage-50" data-id="element-27">
          Mantener la mente activa después de los 50 es una de las mejores
          decisiones que podés tomar por vos mismo.
        </p>

        <div className="bg-sage-900/50 p-8 rounded-2xl border border-sage-700" data-id="element-28">
          <p className="text-xl font-medium mb-6 text-center" data-id="element-29">
            Cuando tenés ejercicios bien hechos y al alcance de la mano, todo
            cambia:
          </p>

          <ul className="space-y-6" data-id="element-30">
            <li className="flex items-start gap-4" data-id="element-31">
              <ArrowRight className="text-[#e8a365] shrink-0 mt-1" size={24} data-id="element-32" />
              <span className="text-lg md:text-xl" data-id="element-33">
                Te sentás con ganas a hacerlos.
              </span>
            </li>
            <li className="flex items-start gap-4" data-id="element-34">
              <ArrowRight className="text-[#e8a365] shrink-0 mt-1" size={24} data-id="element-35" />
              <span className="text-lg md:text-xl" data-id="element-36">
                Tu cabeza se siente más despierta y más ágil.
              </span>
            </li>
            <li className="flex items-start gap-4" data-id="element-37">
              <ArrowRight className="text-[#e8a365] shrink-0 mt-1" size={24} data-id="element-38" />
              <span className="text-lg md:text-xl" data-id="element-39">
                Y empezás a notar la diferencia en tu día a día.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </Section>;
}